export function getElement(element: string | HTMLElement): HTMLElement | null {
  if (typeof element === 'string') {
    return element.startsWith('#')
      ? document.getElementById(element.substring(1))
      : document.querySelector(element)
  } else {
    return element
  }
}
